export interface MqttEvent {
    event: MqttEventType;
    timestamp: number;
}

export enum MqttEventType {
    CLIENT_CONNECTED = "CLIENT_CONNECTED",
    CLIENT_DISCONNECTED = "CLIENT_DISCONNECTED",
    MESSAGE_PUBLISH = "MESSAGE_PUBLISH",
    SESSION_SUBSCRIBED = "SESSION_SUBSCRIBED",
    SESSION_UNSUBSCRIBED = "SESSION_UNSUBSCRIBED",
}

export const mqttEventTypeZh =
    {
        CLIENT_CONNECTED: "客户端连接",
        CLIENT_DISCONNECTED: "客户端断开",
        MESSAGE_PUBLISH: "消息发布",
        SESSION_SUBSCRIBED: "订阅",
        SESSION_UNSUBSCRIBED: "订阅取消",
        UNKNOWN: "未知",
    }
